<template>
  <div class="travel">
    <div class="header">
      <div class="header_qrcode">
        <sr-qr-code :text="qrCodeText"/>
        <p class="t">扫一扫，立即预订机场服务</p>
      </div>
      <div class="header_img">
        <p class="img" :style="{backgroundImage: 'url(' + ad.img + ')'}"></p>
        <p class="title">{{ad.title}}</p>
      </div>
    </div>
    <div class="content">
        <h3>业务</h3>
        <p>公司主营业务包括国内/国际机票预订、国际出行、公务机预订、家门到机舱门的全程高端服务、安保服务和车辆租赁。我们的服务关注您的每一个细节，从您的家门口到机舱门口全程都有专业人员为您服务，机场不论您是国内出行，国际出行，国内转机，国际转机，还是航班延误，航班取消，我们都会专人贴心为您服务，让您的每次出行都安心，贴心，愉快。</p>
        <p>依托集团的高端市场资源，与众多千亿资产企业，及影视明星等达成深度合作，已成为名企指定高端团组出行、接待与服务的最佳机构。</p>
        <p>机场部，高水平服务始终贯穿整个流程：机场设立贵宾迎送部门，贵宾在到达机场后，可享受vip服务的待遇,(登机牌办理.行李托运.专用停车场.专用休息室.独立安检通道.以及私人机下摆渡车等)。</p>
        <br>
        <p>联系方式（北京）</p>
        <p>票务中心： 400 634 0777</p>
        <p>机场处电话：（010）81466718</p>
        <p>总部电话： 86-10-81466165</p>
        <p>网址：www.ylzxvip.com</p>
      </div>
    </div>
  </div>
</template>

<script>
  import SrQrCode from '@/components/QRCode'
  export default {
    components: {
      SrQrCode
    },
    data () {
      return {
        ad: {
          title: '出行',
          img: '//sr-img.oss-cn-beijing.aliyuncs.com/OSS/2017/12/15/5e579dae-9367-4aa0-8395-4a5f2700a6e1.jpg'
        },
        qrCodeText: 'https://m2.ylzxvip.com/reception/#/air-index'
      }
    }
  }
</script>

<style lang="less" scoped>
  .travel {
    width: 1200px;
    margin: 0 auto;
    .header {
      width: 680px;
      margin: 0 auto;
      padding: 30px 0;
      overflow: hidden;
      .header_qrcode {
        float: left;
        width: 200px;
        text-align: center;
        .t {
          padding-top: 6px;
          font-size: 12px;
        }
      }
      .header_img {
        float: right;
        width: 340px;
        .img {
          height: 210px;
          background-color: white;
        }
        .title {
          width: 164px;
          height: 40px;
          line-height: 40px;
          margin: -20px auto 0;
          text-align: center;
          background: rgba(0,0,0,.9);
          color: white;
        }
      }
    }
    .content {
      padding-bottom: 50px;
      border-top: 1px solid #ccc;
      line-height: 2;
      h3 {
        font-size: 24px;
        font-weight: 400;
        padding: 20px 0;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/travel/index.vue